import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */

/**
 * Internal dependencies
 */
import ToolsPanelHeader from '../tools-panel-header';
import { ToolsPanelContext } from '../context';
import { useToolsPanel } from './hook';
import { Grid } from '../../grid';
import { contextConnect } from '../../ui/context';

const ToolsPanel = (props, forwardedRef) => {
  const {
    children,
    label,
    panelContext,
    resetAllItems,
    toggleItem,
    ...toolsPanelProps
  } = useToolsPanel(props);
  return createElement(Grid, _extends({}, toolsPanelProps, {
    columns: 2,
    ref: forwardedRef
  }), createElement(ToolsPanelContext.Provider, {
    value: panelContext
  }, createElement(ToolsPanelHeader, {
    label: label,
    resetAll: resetAllItems,
    toggleItem: toggleItem
  }), children));
};

const ConnectedToolsPanel = contextConnect(ToolsPanel, 'ToolsPanel');
export default ConnectedToolsPanel;
//# sourceMappingURL=component.js.map